<template>
    <v-flex md6 ma-3>
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>Not Found</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <h3>
                   Ruh roh! The page you requested could not be found!
                </h3>
            </v-card-text>
        </v-card>
    </v-flex>
</template>

<script>
    export default {
        name: "not-found",
        data () {
            return {

            }
        },
    }
</script>

<style scoped>
</style>